import { render, staticRenderFns } from "./Released.vue?vue&type=template&id=560eaabc&scoped=true"
import script from "./Released.vue?vue&type=script&lang=js"
export * from "./Released.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560eaabc",
  null
  
)

export default component.exports